// extracted by mini-css-extract-plugin
export default {"input":"MailingList_input__URmqm","content":"MailingList_content__ZYnEL"};